// Image animation on scroll
import $ from 'jquery'
import './bundle'

$(() =>
  $(document).on('simplero:section:load', window.initializeImageTransitioners)
)
